import { TLocalCartItem } from './localCart.types';
import { LOCAL_CART_STORAGE_KEY } from './localCart.constants';

export const loadCartFromStorage = (): TLocalCartItem[] => {
  try {
    const item = localStorage.getItem(LOCAL_CART_STORAGE_KEY);
    if (item) {
      return JSON.parse(item) as TLocalCartItem[];
    }
  } catch (error) {
    console.error('Error loading cart from localStorage:', error);
  }
  return [];
};

export const saveCartToStorage = (items: TLocalCartItem[]): void => {
  try {
    localStorage.setItem(LOCAL_CART_STORAGE_KEY, JSON.stringify(items));
  } catch (error) {
    console.error('Error saving cart to localStorage:', error);
  }
};

export const clearCartFromStorage = (): void => {
  try {
    localStorage.removeItem(LOCAL_CART_STORAGE_KEY);
  } catch (error) {
    console.error('Error clearing cart from localStorage:', error);
  }
};

export const cartItemsEqual = (
  item1: TLocalCartItem,
  item2: TLocalCartItem
): boolean => {
  try {
    const item1Copy = { ...item1 };
    const item2Copy = { ...item2 };
    delete item1Copy.id;
    delete item2Copy.id;
    delete item1Copy.quantity;
    delete item2Copy.quantity;
    return JSON.stringify(item1Copy) === JSON.stringify(item2Copy);
  } catch (error) {
    console.error('Error comparing cart items:', error);
    return false;
  }
};
